import React from "react";
import ReactDOM from "react-dom";
// import Profile from "./components/pages/Profile";
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
// import blue from "@material-ui/core/colors/blue";
// import green from "@material-ui/core/colors/green";
// import "./styles.scss";
// import "animate.css";
// import WOW from "wow.js";

import App from "./App";

// new WOW().init();

// export const theme = createMuiTheme({
//   palette: {
//     type: "light",
//     primary: blue,
//     secondary: green,
//     background: {
//       default: "#999"
//     }
//   },
//   typography: {
//     fontFamily: ["Montserrat"].join(","),
//     fontSize: "18px"
//   },
//   overrides: {
//     MuiLinearProgress: {
//       root: {
//         height: "10px"
//       }
//     },
//     MuiGrid: {
//       item: {
//         padding: "5px"
//       }
//     }
//   }
// });

// class App extends React.Component {
//   state = {
//     name: "Hi, I'm Koen",
//     linkedin: "https://www.linkedin.com/in/koencorneillie"
//   };
//   render() {
//     return (
//       <div className="App">
//         <MuiThemeProvider theme={theme}>
//           <Profile state={this.state} />
//         </MuiThemeProvider>
//       </div>
//     );
//   }
// }

const rootElement = document.getElementById("root");
ReactDOM.render(<App />, rootElement);
